import { RESET_COMPACTING_DC_INVOICE_V2 } from '../../CompactingDC/compactingDC/compactingDC.actionsType';
import {
    CREATE_COMPACTING_INWARD_FAILURE,
    CREATE_COMPACTING_INWARD_REQUEST,
    CREATE_COMPACTING_INWARD_SUCCESS,
    CREATE_USER_FORM_COMPACTING_INWARD,
    FETCH_SINGLE_COMPACTING_INWARD_FAILURE,
    FETCH_SINGLE_COMPACTING_INWARD_REQUEST,
    FETCH_SINGLE_COMPACTING_INWARD_SUCCESS,
    FETCH_COMPACTING_INWARD_FAILURE,
    FETCH_COMPACTING_INWARD_REQUEST,
    FETCH_COMPACTING_INWARD_SUCCESS,
    NAVIGATE_COMPACTING_INWARD_DETAILS,
    NAVIGATE_COMPACTING_INWARD,
    COMPACTING_INWARD_USERFORM_RESET,
    UPDATE_COMPACTING_INWARD_FAILURE,
    UPDATE_COMPACTING_INWARD_REQUEST,
    UPDATE_COMPACTING_INWARD_SUCCESS,
    DELETE_COMPACTING_INWARD_REQUEST,
    DELETE_COMPACTING_INWARD_SUCCESS,
    DELETE_COMPACTING_INWARD_FAILURE,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_COMPACTING_INWARD,
    RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID,
    FETCH_COMPACTING_DIV_DESPATCH_INVOICE_SUCCESS,
    FETCH_COMPACTING_DIV_DESPATCH_INVOICE_FAILURE,
    FETCH_COMPACTING_DIV_DESPATCH_INVOICE_REQUEST,
    RESET_COMPACTING_DIV_INWARD_INVOICE_V2
} from './compactingDivInward.actionsType';

export const COMPACTING_DIVISION_INWARD = 'compactingDivisionInward';

let initialState = {
    loading: false,
    compactingInward: [],
    pendingCompactingInward: [],
    activeKey: 1,
    compactingInwardId: '',
    mainId: '',
    compactingDivDespatchInvoiceV2: [],
    compactingInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedCompactingInward: {},
    isCompactingInward: false,
    compactingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    goBack: true
};

export let compactingDivisionInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_COMPACTING_INWARD_REQUEST:
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST:
        case CREATE_COMPACTING_INWARD_REQUEST:
        case FETCH_SINGLE_COMPACTING_INWARD_REQUEST:
        case UPDATE_COMPACTING_INWARD_REQUEST:
        case DELETE_COMPACTING_INWARD_REQUEST:
        case FETCH_COMPACTING_DIV_DESPATCH_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInward: updatePayload
            };
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingCompactingInward: updatePayload
            };
        case CREATE_COMPACTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                //compactingInwardId: updatePayload[0]?.fldID,
                mainId: updatePayload,
                // activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_COMPACTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompactingInward: updatePayload,
                compactingInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_COMPACTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompactingInward: {},
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case DELETE_COMPACTING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedCompactingInward: {}
            };
        case FETCH_COMPACTING_DIV_DESPATCH_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingDivDespatchInvoiceV2: updatePayload
            };
        case FETCH_COMPACTING_INWARD_FAILURE:
        case FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_COMPACTING_INWARD_FAILURE:
        case CREATE_COMPACTING_INWARD_FAILURE:
        case UPDATE_COMPACTING_INWARD_FAILURE:
        case DELETE_COMPACTING_INWARD_FAILURE:
        case FETCH_COMPACTING_DIV_DESPATCH_INVOICE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_INWARD:
            return {
                ...state,
                loading: false,
                compactingInwardForm: {
                    ...state.compactingInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_COMPACTING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case COMPACTING_INWARD_USERFORM_RESET:
            return {
                ...state,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                compactingInwardId: '',
                detailsId: [],
                activeKey: 1,
                selectedCompactingInward: {}
            };
        case RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID:
            return {
                ...state,
                compactingInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_COMPACTING_INWARD_DETAILS:
            return {
                ...state,
                isCompactingInward: true,
                compactingInwardSelectedValue: updatePayload.compactingInwardSelectedValue
            };
        case NAVIGATE_COMPACTING_INWARD:
            return {
                ...state,
                isCompactingInward: false,
                goBack: false
            };
        case RESET_COMPACTING_DIV_INWARD_INVOICE_V2:
            return {
                ...state,
                compactingDivDespatchInvoiceV2: []
            };
        default:
            return state;
    }
};
